import {
  globalHoverOnWhiteBG,
  toArray,
  InlineAlert,
  formatTextToCamelCase,
  icons,
  colors,
  boxShadow0,
  OKELink,
  transition,
  colors2,
  LoaderCircleV2,
  Divider,
  ActionMenu,
  UI_CAPTION_BOLD_DF,
  UI_CAPTION_SEMIBOLD_DF,
  useHandleClickOutside,
} from "oolib";
import React, { Fragment, useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";

import {
  StyledContainer,
  StyledDragHandleWrapper,
  StyledContentWrapper,
  StyledIconAndTitleWrapper,
  StyledTitleWrapper,
  StyledTitle,
  StyledRightActionsWrapper,
  StyledTitleInput,
  StyledSubtitleWrapper,
  StyledSubtitle,
  StyledHr,
  StyledMoreContentWrapper,
  StyledDescHelpText,
  StyledEmbeddedActionsContainer,
  StyledErrorWrapper,
  StyledErrorContent,
  StyledBadgeContainer,
} from "./styled";
import {
  ButtonGhost,
  ButtonPrimary,
  ButtonSecondary,
} from "oolib/dist/v2/components/Buttons";
import { Tag as TagComp } from "oolib/dist/v2/components/Tags";
import { TooltipV2 } from "oolib";
import LexicalTextEditor from "@/components/inputs/TextEditor/LexicalTextEditor";
import { SM_UIContent } from "@/_self_managed/SM_UIContent";
import { AnimatePresence } from "framer-motion";
const { DotsSixVertical } = icons;

const StyledBorderWrapper = styled.div`
  /* border: 1px solid ${colors2.grey10}; */
  ${({ onClick }) =>
    !!onClick &&
    css`
      cursor: pointer;
      ${globalHoverOnWhiteBG};
    `}
  /* box-shadow: 0px 4px 10px 0px ${colors2.shadowDefault}; */
  border-radius: 6px;
  ${transition("background-color")};
  ${({ theme, editable }) =>
    editable &&
    css`
      background-color: ${colors.white};
      border-color: ${theme.colors.primaryColor100};
    `};
  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${({ invert }) =>
        invert ? colors2.grey80 : colors2.grey5};
    `}
`;

export const DraggableBlock = ({
  id,
  title,
  titleWeight,
  icon,
  iconProps,
  iconAfter,
  iconAfterProps,
  loader, // sometimes, like in tagsmanagerv2 - where we want to show a loading state representing the fact that in the background this 'draggable block tag' is getting saved to db. this prop is useful for such things
  desc,
  showDescField,
  subtitle,
  actionMenu, //multi -> renders actionMenu and is a object with actionMenu props
  action: _action, //single -> renders a button and is a object with button props
  editable,
  placeholder,
  descPlaceholder,
  onTitleInputChange,
  onDescInputChange,
  maxLength,
  tempCustomComp, //remove once we figure how to deal with repeater sidebar blocks
  disableDrag = false, //shows it in disabled state
  hideDrag = false, //removes it
  customJSXBlock,
  customJSXInline,
  onClick,
  isActive,
  inlineAlertMsg: inlineAlertMsgProp,
  contentWrapperStyle = {
    padding: "0.9rem 0", 
  },
  containerStyle,
  showActionsOnHover = false,
  alignActions = "center",
  onBlur,
  levelColor,
  statusDisplay,
}) => {
  // Normalize action to always be an array (can be passed as single object or array)
  const action =
    Array.isArray(_action) || typeof _action === "object"
      ? toArray(_action)
      : [];


  const cardRef = useRef();
  const [isFocused, setIsFocused] = useState(false);

  useHandleClickOutside(cardRef, null, {
    capture: true,
    callback: () => {
      if (editable && !(inlineAlertMsg || inlineAlertMsgProp)) {
        onBlur?.();
        setIsFocused(false);
      }
    },
  });

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const genIcon = ({ icon, iconProps = {} }) => {
    const Comp = icons[icon];
    if (!Comp) return null;
    return (
      <div style={{ flexShrink: 0, marginTop: "-0.1rem", display: "flex" }}>
        <Comp
          weight={"bold"}
          size={16}
          {...iconProps} //if iconProps are passed they will override the above defaults
        />
      </div>
    );
  };

  const textInputRef = useRef(null);

  useEffect(() => {
    if (editable) {
      textInputRef.current.focus();
    }
  }, [editable]);

  const [inlineAlertMsg, setInlineAlertMsg] = useState("");
  // useEffect(() => {
  //   setInlineAlertMsg(inlineAlertMsgProp)
  // },[inlineAlertMsgProp])

  const applyTitleWeight = (titleWeight) => {
    if (!titleWeight) return {};
    //else
    return { [titleWeight]: true };
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      const checkBtn = action.find((v) => v.icon === "Check");
      checkBtn?.onClick?.();
    }
  };

  const embeddedActions = action.filter((a) => !!a.inline);
  const nonEmbeddedActions = action.filter((a) => !a.inline);

  // for customJSXInline there is an order property available with the flexbox, to control where this flexItem should appear.

  return (
    <Fragment>
      <AnimatePresence initial={false}>
        {(inlineAlertMsg || inlineAlertMsgProp) && (
          <StyledErrorWrapper
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ type: "spring", bounce: 0 }}
          >
            <StyledErrorContent>
              <UI_CAPTION_SEMIBOLD_DF>
                {inlineAlertMsg || inlineAlertMsgProp}
              </UI_CAPTION_SEMIBOLD_DF>
            </StyledErrorContent>
          </StyledErrorWrapper>
        )}
      </AnimatePresence>
      <StyledBorderWrapper
        isActive={isActive}
        onClick={onClick}
        editable={editable}
      >
        <StyledContainer
          editable={editable}
          style={containerStyle}
          showActionsOnHover={showActionsOnHover}
        >
          {hideDrag ? (
            <div style={{ paddingLeft: "1rem" }} />
          ) : (
            <StyledDragHandleWrapper
              style={{ cursor: disableDrag ? "not-allowed" : "grab" }}
            >
              <DotsSixVertical
                size={16}
                color={disableDrag ? colors2.grey20 : colors2.black}
              />
            </StyledDragHandleWrapper>
          )}
          <StyledContentWrapper style={contentWrapperStyle} ref={cardRef}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.6rem",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <StyledIconAndTitleWrapper>
                {icon && genIcon({ icon, iconProps })}
                <StyledTitleWrapper>
                  {editable && typeof title === "string" ? ( //cuz title could be jsx also, and this string check is just a safeguard from breaking the platfrom
                    <StyledTitleInput
                      ref={textInputRef}
                      type="text"
                      placeholder={placeholder}
                      className="UI_BODY_SEMIBOLD_SM_DF"
                      maxLength={maxLength}
                      onKeyUp={(e) => {
                        if (title.length === maxLength) {
                          setInlineAlertMsg("Max Character Length reached!");
                        } else {
                          inlineAlertMsg && setInlineAlertMsg(undefined);
                        }
                      }}
                      onKeyDown={handleKeyDown}
                      value={title}
                      onChange={(e) => onTitleInputChange(id, e.target.value)}
                    />
                  ) : (
                    <StyledTitle
                      className="StyledTitle"
                      {...applyTitleWeight(titleWeight)}
                    >
                      {title}
                    </StyledTitle>
                  )}
                </StyledTitleWrapper>
                {iconAfter && ( //can pass multiple as an array
                  <div
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    {toArray(iconAfter).map((d, idx) => {
                      const thisIconAfterProps = toArray(iconAfterProps || [])[
                        idx
                      ];
                      return genIcon({
                        icon: d,
                        iconProps: thisIconAfterProps,
                      });
                    })}
                  </div>
                )}
                {editable && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.4rem",
                    }}
                  >
                    {embeddedActions &&
                      embeddedActions.map((a, i) => {
                        const buttonComps = {
                          ButtonGhost,
                          ButtonSecondary,
                          ButtonPrimary,
                        };
                        const ButtonComp = buttonComps[a.comp] || ButtonGhost;

                        const onClick = (event) => {
                          // purpose of this onClick function is to handle button clicks by calling the provided onClick function (if any), and resetting the inline alert message state.
                          // this function ensures that the existing onClick function is only called if it is a function
                          // Call the onClick function provided in the action prop, if it exists and is a "function".
                          // This is done using a type check to ensure that the function is actually a function before calling it.
                          // If the function exists, it is called with the event object passed in as an argument.
                          if (typeof a.onClick === "function") {
                            a.onClick(event);
                          }
                          inlineAlertMsg !== undefined &&
                            setInlineAlertMsg(undefined);
                        };

                        // Strip our custom `tooltip` field before spreading
                        // onto ButtonComp — it has no meaning to the button.
                        const { tooltip, ...buttonProps } = a;
                        const button = (
                          <ButtonComp
                            stopPropagation
                            key={i}
                            {...buttonProps}
                            onClick={onClick}
                            style={{ height: "2.4rem", width: "2.4rem" }}
                          />
                        );
                        if (tooltip) {
                          return (
                            <TooltipV2 key={i} text={tooltip} placement="bottom" showDelay={200}>
                              {button}
                            </TooltipV2>
                          );
                        }
                        return button;
                      })}
                  </div>
                )}
              </StyledIconAndTitleWrapper>
              {subtitle && (
                <StyledSubtitle>{subtitle}</StyledSubtitle>
              )}
              {(editable || showDescField) && (
                <>
                  <StyledHr />
                  <StyledSubtitleWrapper
                    onKeyDown={handleKeyDown}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                  >
                    <LexicalTextEditor
                      placeholderColor={colors2.grey50}
                      id={`desc-${id}`}
                      placeholder={"Add description here..."}
                      value={desc}
                      onChange={(editorId, value) =>
                        onDescInputChange(id, value)
                      }
                      variant="simple"
                      readOnly={!editable}
                      typo="UI_CAPTION_DF"
                      textColor={colors2.grey50}
                    />
                  </StyledSubtitleWrapper>
                  <AnimatePresence initial={false}>
                    {isFocused && (
                      <StyledDescHelpText
                        initial={{ opacity: 0 }}
                        exit={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                      >
                        <UI_CAPTION_BOLD_DF>
                          {
                            SM_UIContent.SM_ThemesManager.descInput
                              .keyCombination
                          }
                        </UI_CAPTION_BOLD_DF>
                        <UI_CAPTION_SEMIBOLD_DF>
                          {
                            SM_UIContent.SM_ThemesManager.descInput
                              .additionalText
                          }
                        </UI_CAPTION_SEMIBOLD_DF>
                      </StyledDescHelpText>
                    )}
                  </AnimatePresence>
                </>
              )}
              {tempCustomComp}
            </div>
          </StyledContentWrapper>

          {customJSXInline ? customJSXInline : null}
          {(actionMenu || action || loader) && (
            <StyledRightActionsWrapper
              id={`${id}-actions`}
              showActionsOnHover={showActionsOnHover}
              loader={
                nonEmbeddedActions && nonEmbeddedActions.length > 0 && loader
              }
              alignActions={alignActions}
            >
              {nonEmbeddedActions &&
                nonEmbeddedActions.length > 0 &&
                loader && <LoaderCircleV2 S />}
              {nonEmbeddedActions &&
                nonEmbeddedActions.map((a, i) => {
                  const buttonComps = {
                    ButtonGhost,
                    ButtonSecondary,
                    ButtonPrimary,
                  };
                  const ButtonComp = buttonComps[a.comp] || ButtonGhost;

                  const onClick = (event) => {
                    // purpose of this onClick function is to handle button clicks by calling the provided onClick function (if any), and resetting the inline alert message state.
                    // this function ensures that the existing onClick function is only called if it is a function
                    // Call the onClick function provided in the action prop, if it exists and is a "function".
                    // This is done using a type check to ensure that the function is actually a function before calling it.
                    // If the function exists, it is called with the event object passed in as an argument.
                    if (typeof a.onClick === "function") {
                      a.onClick(event);
                    }
                    inlineAlertMsg !== undefined &&
                      setInlineAlertMsg(undefined);
                  };

                  return (
                    <ButtonComp
                      stopPropagation
                      key={i}
                      {...{ ...a }}
                      onClick={onClick}
                      style={{ height: "2.4rem", width: "2.4rem" }}
                    />
                  );
                })}

              {actionMenu &&
                toArray(actionMenu).map((a, i) => (
                  <ActionMenu
                    key={a.display ? formatTextToCamelCase(a.display) : i}
                    {...a}
                  />
                ))}
            </StyledRightActionsWrapper>
          )}
          {!editable && (
            <StyledEmbeddedActionsContainer
              levelColor={levelColor}
              showActionsOnHover={showActionsOnHover}
              loader={embeddedActions && embeddedActions.length > 0 && loader}
            >
              {embeddedActions && embeddedActions.length > 0 && loader && (
                <LoaderCircleV2 S />
              )}
              {embeddedActions &&
                toArray(embeddedActions).map((a, i) => {
                  const buttonComps = {
                    ButtonGhost,
                    ButtonSecondary,
                    ButtonPrimary,
                  };
                  const ButtonComp = buttonComps[a.comp] || ButtonGhost;

                  const onClick = (event) => {
                    // purpose of this onClick function is to handle button clicks by calling the provided onClick function (if any), and resetting the inline alert message state.
                    // this function ensures that the existing onClick function is only called if it is a function
                    // Call the onClick function provided in the action prop, if it exists and is a "function".
                    // This is done using a type check to ensure that the function is actually a function before calling it.
                    // If the function exists, it is called with the event object passed in as an argument.
                    if (typeof a.onClick === "function") {
                      a.onClick(event);
                    }
                    inlineAlertMsg !== undefined &&
                      setInlineAlertMsg(undefined);
                  };

                  // Strip our custom `tooltip` field before spreading
                  // onto ButtonComp — it has no meaning to the button.
                  const { tooltip, ...buttonProps } = a;
                  const button = (
                    <ButtonComp
                      stopPropagation
                      key={i}
                      {...buttonProps}
                      onClick={onClick}
                      style={{
                        height: "2.4rem",
                        width: "2.4rem",
                        padding: "0.4rem",
                      }}
                    />
                  );
                  if (tooltip) {
                    return (
                      <TooltipV2 key={i} text={tooltip} placement="bottom" showDelay={200}>
                        {button}
                      </TooltipV2>
                    );
                  }
                  return button;
                })}
            </StyledEmbeddedActionsContainer>
          )}
          {!editable && statusDisplay && (
            <StyledBadgeContainer>
              <TagComp display={statusDisplay} variant="default"/>
            </StyledBadgeContainer>
          )}
        </StyledContainer>
        {customJSXBlock ? customJSXBlock : null}
      </StyledBorderWrapper>
    </Fragment>
  );
};
